/* eslint-disable @typescript-eslint/no-explicit-any */
import { getUserInfo } from "@/lib/token";
import { apiServices } from "@/services/api.services";
import { email_file } from "@/services/global.services";

export const getEmailFileUrl = async (
  filePath: string
): Promise<{ url?: string; error?: any; message?: string | null }> => {
  const tempUserData = getUserInfo();

  const payload = {
    company_id: tempUserData?.company_id,
    data: { file_path: filePath },
  };

  const { data, error, message } = await apiServices<any>(
    email_file.get,
    "post",
    payload
  );

  if (data?.result?.metadata?.url) {
    return { url: data.result.metadata.url };
  }

  return { error, message };
};
